import styled, { css } from 'styled-components';
/**
 * Tag label container
 */
export const tagLabelContainerStyles = () => css ``;
export const TagLabelContainer = styled.span `
	${tagLabelContainerStyles}
`;
//# sourceMappingURL=tag-label.styled.js.map